export class LanguageOption {
	public language: string;
	public label: string = "";
	public langLabel: string = "";
	public direction: string;
	public langCode: string;
}
